import { useMemo } from 'react'
import { useTheme } from '@mui/material'

export const useFitBoundsPadding = (padding: number) => {
  const theme = useTheme()

  const fitBoundsOptions = useMemo(() => {
    const spacing = parseInt(theme.spacing(padding), 10)

    return {
      padding: {
        top: spacing,
        right: spacing,
        bottom: spacing,
        left: spacing,
      },
    }
  }, [theme, padding])

  return fitBoundsOptions
}
